module.exports = __webpack_public_path__ + "images/10d2e5997c1f04da7428738bcb75106238e87adc2141b8d5372a5a60454c6f73.svg";